<template>
  <FormGroup :error-container="errorContainer" :label="label" :name="name" :floating="floating">
    <FmSelect :value="proxyValue" :options="options" :icons="icons" :disabled="disabled"
              @input="proxyValue = $event"/>
  </FormGroup>
</template>

<script>
import FormGroup from '@modules/shared/components/form/FormGroup';
import FmSelect from '@modules/shared/components/form/FmSelect';
import {Genders} from '@modules/guest/bought-lead/constants';

const ICONS = {
  M: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2H9.5zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/></svg>`,
  F: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5z"/></svg>`,
};

export default {
  name: 'GenderSelect',
  components: { FormGroup, FmSelect },
  model: { prop: 'value', event: 'input' },
  props: {
    name:           { type: String,  default: 'gender' },
    label:          { type: String,  default: 'Gender' },
    value:          { type: String,  default: '' },
    disabled:       { default: false },
    errorContainer: { type: String,  default: '' },
    floating:       { type: Boolean, default: false },
  },
  computed: {
    options: () => Genders,
    icons:   () => ICONS,
    proxyValue: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
};
</script>
